<template>
  <v-list color="primary">
    <main-menu-link routeName="map"></main-menu-link>
    <main-menu-link routeName="lures"></main-menu-link>
    <main-menu-link routeName="journal"></main-menu-link>
    <v-list-group>
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props" title="Dati" prepend-icon="mdi-database" color="white"></v-list-item>
      </template>
      <v-list bg-color="black" color="primary">
        <main-menu-link routeName="data"></main-menu-link>
        <v-list bg-color="black" class="pl-4" v-if="['history', 'transferlog'].includes(route.name)">
          <main-menu-link color="primary" routeName="transferlog"></main-menu-link>
          <main-menu-link color="primary" routeName="history"></main-menu-link>
        </v-list>
        <main-menu-link routeName="media"></main-menu-link>
        <main-menu-link routeName="offline_packages"></main-menu-link>
        <main-menu-link routeName="dump_restore"></main-menu-link>
      </v-list>
    </v-list-group>
    <!-- <main-menu-link routeName="manual"></main-menu-link> -->
    <!-- <v-list-group>
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props" title="Documentazione" prepend-icon="mdi-file-document-multiple-outline" color="white"></v-list-item>
      </template>
      <v-list bg-color="black" color="primary">
        <main-menu-link routeName="news"></main-menu-link>
      </v-list>
    </v-list-group> -->


    <main-menu-link routeName="account"></main-menu-link>
    <main-menu-link routeName="settings"></main-menu-link>
    <!-- <main-menu-link routeName="system"></main-menu-link> -->
  </v-list>
  <v-list color="lime">
    <main-menu-link routeName="devel"></main-menu-link>
    <main-menu-link routeName="runtimeTests"></main-menu-link>
  </v-list>
</template>


<script setup>

import { useRuntimeStore } from "@/store/runtime"
import { useRouter } from 'vue-router'
import { useRoute } from 'vue-router'
import MainMenuLink from '@/components/MainMenuLink.vue'


const router = useRouter();

const runtimeStore = useRuntimeStore();

// get route by name
const getRoute = (name) => {
  return router.resolve({ name: name });
}

const route = useRoute()


</script>

<style scoped>
.v-list-group__items .v-list-item {
  padding-inline-start: 3em !important;
}
</style>
